import { render, staticRenderFns } from "./QuestionSelect.vue?vue&type=template&id=c2a68302&scoped=true&"
import script from "./QuestionSelect.vue?vue&type=script&lang=js&"
export * from "./QuestionSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSelect.vue?vue&type=style&index=0&id=c2a68302&lang=scss&scoped=true&"
import style1 from "./QuestionSelect.vue?vue&type=style&index=1&id=c2a68302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a68302",
  null
  
)

export default component.exports